import React, { useState } from 'react';
import Popup from 'reactjs-popup';
import { FaTimes, FaClock, FaCheck, FaSearch, FaTrash } from 'react-icons/fa';
 
const ConfirmationModalAdd = ({ isOpen, onClose, onSave, onCancel, notifOptions }) => {
    const [checkNotifGuest, setCheckNotifGuest] = useState(false);
    const toggleCheckNotifGuest = () => { if (initialGuestStatus!=="Confirmed") setCheckNotifRequestor(!checkNotifGuest); setCheckNotifGuest((prevCheckNotifGuest) => !prevCheckNotifGuest); };
    const [checkNotifRequestor, setCheckNotifRequestor] = useState(false);
    const toggleCheckNotifRequestor = () => { setCheckNotifRequestor((prevCheckNotifRequestor) => !prevCheckNotifRequestor); };
    const [ initialGuestStatus, setInitialGuestStatus] = useState("Under review");

    const resetInputs = () => { setCheckNotifGuest(false); setCheckNotifRequestor(false); setInitialGuestStatus("Under review");  };
 
    const handleSave = () => {
      onSave((notifOptions==="true") ? checkNotifGuest : true,(notifOptions==="true") ? checkNotifRequestor : true,(notifOptions==="true") ? initialGuestStatus : "Confirmed");  
      resetInputs();
    };
 
    return (
        <Popup
            open={isOpen}
            onClose={() => {resetInputs(); onClose();}}
            contentStyle={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                padding: '20px',
                border: '1px solid #d9d7d7',
                borderRadius: '5px',
                backgroundColor: '#fff',
                boxSizing: 'border-box',
            }}
            overlayStyle={{
                backgroundColor: 'rgba(0, 0, 0, 0.2)',
                zIndex: 1040,
            }}
        >
            <div className="modal-content" style={{ color: 'darkblue' }}>
                <h5 className='popupTitle' style={{ userSelect: 'none'}}>Add guest</h5>
                <p className='popup-text' style={{ userSelect: 'none'}}>Are you sure you want to add this guest to the event?</p>
                {(notifOptions==="true") && (<>
                      <div className="guest-actions" style={{ userSelect: 'none'}}>
                      <span className="font-mars-centra" style={{ userSelect: 'none' }}>Guest status:</span>
                        <button
                          id={'Declined'}
                          className={`btn-remove ${initialGuestStatus === 'Declined' ? 'Declined' : ''}`}
                          onClick={(e) => {
                            e.preventDefault();
                            setCheckNotifRequestor(true);
                            setCheckNotifGuest(true);
                            setInitialGuestStatus("Declined");
                          }}
                        >
                          <FaTimes />
                        </button>
                        <button
                          id={'Tentative'}
                          className={`btn-timer ${initialGuestStatus === 'Tentative' ? 'Tentative' : ''}`}
                          onClick={(e) => {
                            e.preventDefault();
                            setCheckNotifRequestor(true);
                            setCheckNotifGuest(true);
                            setInitialGuestStatus("Tentative");
                          }}
                        >
                          <FaClock />
                        </button>
                        <button
                          id={'Confirmed'}
                          className={`btn-confirm ${initialGuestStatus === 'Confirmed' ? 'Confirm' : ''}`}
                          onClick={(e) => {
                            e.preventDefault();
                            setCheckNotifRequestor(true);
                            setCheckNotifGuest(true);
                            setInitialGuestStatus("Confirmed");
                          }}
                        >
                          <FaCheck />
                        </button>
                        <button
                          id={'Confirmed'}
                          className={`btn-confirm ${initialGuestStatus === 'Under review' ? 'UnderReview' : ''}`}
                          onClick={(e) => {
                            e.preventDefault();
                            setCheckNotifRequestor(false);
                            setCheckNotifGuest(false);
                            setInitialGuestStatus("Under review");
                          }}
                        >Under review</button>
                      </div>
                    <p className='popup-text' style={{ userSelect: 'none'}}></p>
                    <div className="form-group" style={{ userSelect: 'none'}}>
                          <div className="align-items-center mb-2 d-flex">
                            <input className={(initialGuestStatus !== 'Under review') ? 'form-check-input-custom2 form-check-input' : 'form-check-input-greyed form-check-input' } type="checkbox" id="chkCheckNotifGuest" checked={checkNotifGuest} 
                                   onChange={(initialGuestStatus !== 'Under review') ? toggleCheckNotifGuest : () => {}} />
                            <span className="font-mars-centra" 
                                  style={(initialGuestStatus !== 'Under review') ? { userSelect: 'none', cursor: 'pointer' } : { color: '#D3D3D3', userSelect: 'none', cursor: 'default' }} 
                                  onClick={(initialGuestStatus !== 'Under review') ? toggleCheckNotifGuest : () => {}}>Notify guest{(initialGuestStatus === 'Under review') ? " (no guest notification when adding a guest with \"Under review\" status)" : ""}</span>
                          </div>
                          <div className="align-items-center mb-2 d-flex">
                            <input className={((initialGuestStatus !== 'Under review') && checkNotifGuest) || (initialGuestStatus==="Confirmed") ? 'form-check-input-custom2 form-check-input' : 'form-check-input-greyed form-check-input' }  type="checkbox" id="chkCheckNotifRequestor" checked={checkNotifRequestor}
                                   onChange={((initialGuestStatus !== 'Under review') && checkNotifGuest) || (initialGuestStatus==="Confirmed") ? toggleCheckNotifRequestor : () => {}} />
                            <span className="font-mars-centra" 
                                  style={((initialGuestStatus !== 'Under review') && checkNotifGuest) || (initialGuestStatus==="Confirmed") ? { userSelect: 'none', cursor: 'pointer' } : { color: '#D3D3D3', userSelect: 'none', cursor: 'default' }} 
                                  onClick={((initialGuestStatus !== 'Under review') && checkNotifGuest) || (initialGuestStatus==="Confirmed") ? toggleCheckNotifRequestor : () => {}}>Notify requestor</span>
                          </div>
                    </div>
                    </>
                )}
                <div className="modal-actions" style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                    <button className="btn btn-cancel" onClick={onCancel}>CANCEL</button>
                    <button className="btn btn-save" onClick={handleSave}>SAVE</button>
                </div>
            </div>
        </Popup>
    );
};
 
export default ConfirmationModalAdd;